import { render, Suspense } from "@wordpress/element";
import withAppProviders from "withAppProviders";
import Block from "./Block";

const EventBookingFrontend = ({ attributes }) => {
	return <Block attributes={attributes} />;
};

const EventBooking = withAppProviders(EventBookingFrontend)();
export default EventBooking;

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-vino-wine-event-booking");
	if (element) {
		render(
			<Suspense fallback={<div className="wp-block-placeholder" />}>
				<EventBooking />
			</Suspense>,
			element
		);
	}
});
